const ACCOUNT = 'tatauy'

module.exports = {
  // Theming
  theme: 'tatauyqa',

  account: ACCOUNT,

  // Ecommerce Platform
  platform: 'vtex',

  // Platform specific configs for API
  api: {
    storeId: ACCOUNT,
    workspace: 'master',
    environment: 'vtexcommercestable',
    hideUnavailableItems: true,
  },

  // Default channel
  session: {
    currency: {
      code: 'UYU',
      symbol: '$',
    },
    locale: 'es-uy',
    channel: '{"salesChannel":"4","regionId":""}',
    country: 'URY',
    postalCode: null,
    person: null,
  },

  // Production URLs
  storeUrl: 'https://tata.com.uy',
  secureSubdomain: 'https://secure.tata.com.uy/',
  //! TODO: CHANGE BEFORE DEPLOY
  checkoutUrl: 'https://secure.tata.com.uy/checkout',
  loginUrl: 'https://secure.tata.com.uy/api/io/login',
  accountUrl: 'https://secure.tata.com.uy/api/io/account',

  // Lighthouse CI
  lighthouse: {
    server: process.env.BASE_SITE_URL || 'http://localhost:9000',
    pages: {
      home: '/',
      pdp: '/aceite-de-oliva-extra-virgen-ta-ta-500-ml-56211/p',
      collection: '/almacen',
    },
  },

  // E2E CI
  cypress: {
    pages: {
      home: '/',
      pdp: '/cerveza-heineken-no-retornable-1-l-162/p',
      collection: '/cervezas',
      collection_filtered:
        '/cervezas/?category-1=bebidas&category-2=cervezas&brand=heineken&facets=category-1%2Ccategory-2%2Cbrand&sort=score_desc&page=0',
      search: '/s?q=heineken',
    },
  },

  analytics: {
    // https://developers.google.com/tag-platform/tag-manager/web#standard_web_page_installation,
    gtmContainerId: 'GTM-PHQC9D6',
  },
}
